import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { buildVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/volumeCapsule/state/config/configslice';
import { VolumeCapsuleState } from 'widgets/liquiditySummary/volumeCapsule/state/VolumeCapsuleState';
import { VolumeCapsuleActionPayload } from 'widgets/liquiditySummary/volumeCapsule/state/actions';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: configReducer } = buildVolumeCapsuleConfigSlice();

const capsuleStateReducer = combineReducers<VolumeCapsuleState>({
    config: configReducer,
});

export const volumeCapsuleReducer = createWidgetsReducer<
    VolumeCapsuleState,
    VolumeCapsuleActionPayload
>(WidgetType.VOLUME_CAPSULE, capsuleStateReducer);
